/* eslint-disable @typescript-eslint/no-explicit-any */
import * as _ from "lodash";
import { rem } from "@mantine/core";
import { notifications } from "@mantine/notifications";
import {
  IconAlertTriangle,
  IconCheck,
  IconInfoCircle,
  IconX,
} from "@tabler/icons-react";

export function sortByUpdatedAt(
  a: { updatedAt: string | number | Date },
  b: { updatedAt: string | number | Date },
) {
  return new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime();
}
export function sortByCreateDate(
  a: { date: string | number | Date },
  b: { date: string | number | Date },
) {
  return new Date(b.date).getTime() - new Date(a.date).getTime();
}
export function sortByDate(
  a: string | number | Date,
  b: string | number | Date,
) {
  return new Date(b).getTime() - new Date(a).getTime();
}
export function sortByCreatedAt(
  a: { createdAt: string | number | Date },
  b: { createdAt: string | number | Date },
) {
  return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
}
export const addCharacterS = (value: any) => {
  if (parseInt(value) != 1) {
    return "s";
  }
  return "";
};
export const appShowNotification = ({ message, title, variant, type }: any) => {
  const xIcon = <IconX style={{ width: rem(20), height: rem(20) }} />;
  const checkIcon = <IconCheck style={{ width: rem(20), height: rem(20) }} />;
  const info = <IconInfoCircle style={{ width: rem(20), height: rem(20) }} />;
  const alert = (
    <IconAlertTriangle style={{ width: rem(20), height: rem(20) }} />
  );
  let color = "blue";
  let iconNotification = info;
  if (type == "success") {
    color = "#003554";
    iconNotification = checkIcon;
  }
  if (type == "error") {
    iconNotification = xIcon;
    color = "red";
  }
  if (type == "warning") {
    color = "orange";
    iconNotification = alert;
  }
  return notifications.show({
    message: message || "",
    title: title || "Notification",
    position: "bottom-right",
    variant: variant || "default",
    radius: 4,
    color: color,
    icon: iconNotification,
  });
};
export const TEMPLATE_OPTIONS = {
  SECTION: "SECTION",
  SUB_SECTION: "SUB_SECTION",
  FIELD: "FIELD",
  TEXT_BOX: "TEXT_BOX",
};
export const sortByReferenceIds = (objects: any, referenceIds: any) => {
  try {
  if (!objects) {
    return;
  }
  if (referenceIds === null) return objects;
  const objectMap = objects.map((obj: any) => {
    let indexOfObjInSort = referenceIds.indexOf(obj.id);
    if (indexOfObjInSort == -1) {
      indexOfObjInSort = referenceIds.length;
    }
    return {
      ...obj,
      order: indexOfObjInSort,
    };
  });
  const sorted = _.sortBy(objectMap, "order");
  return sorted;
  } catch (error) {
    console.error("Error sorting by reference IDs:", error);
    return objects;
  }
};
export const referralUrl = "https://manta.referral-factory.com/UeFeb8";
export const referralTrackUrl =
  "https://manta.referral-factory.com/UeFeb8/referrals";

export const onGetReferralLink = () => {
  window.open(referralUrl, "_blank");
};

export const onTrackReferral = () => {
  window.open(referralTrackUrl, "_blank");
};

export const PLANS = {
  FREE: "FREE",
  PREMIUM_MONTH: "PREMIUM_MONTH",
  PREMIUM_YEAR: "PREMIUM_YEAR",
  ESSENTIAL_MONTH: "ESSENTIAL_MONTH",
  ESSENTIAL_YEAR: "ESSENTIAL_YEAR",
};

export const LOOKUP_KEYS = {
  PREMIUM_MONTH: "manta_premium_monthly",
  PREMIUM_YEAR: "manta_premium_yearly",
  ESSENTIAL_MONTH: "manta_essential_monthly",
  ESSENTIAL_YEAR: "manta_essential_yearly",
};

export const RECORD_TYPES = {
  HISTORY: "HISTORY",
  EXAM: "EXAM",
  ASSESSMENT: "ASSESSMENT",
  PLAN: "PLAN",
  COMMUNICATION: "COMMUNICATION",
  OTHER: "OTHER",
};
export const interpolateExponential = (db: any) => {
  const minHeight = 2;
  const maxHeight = 93;
  const scale = 8;
  const lowerBound = -90; // lower = more sensitive

  const normalizedDb = (db - lowerBound) / -lowerBound; // Maps lowerbound to 0 -> 0 to 1

  const height = Math.min(
    Math.max(2 ** (normalizedDb * scale), minHeight),
    maxHeight,
  );
  console.log({ db });
  console.log({ height });

  return height;
};

export const AudioDatabase = {
  DB_NAME: "VET_SCRIBER_AUDIO_DB",
  DB_NAME_QUICK_RECORD: "VET_SCRIBER_AUDIO_DB_QUICK_RECORD",
  STORE: "VET_SCRIBER_AUDIO_STORE",
  STORE_QUICK_RECORD: "VET_SCRIBER_AUDIO_STORE_QUICK_RECORD",
  PREFIX_RECORD: "PATIENT_CASE_RECORDS_",
  PREFIX_QUICK_RECORD: "QUICK_RECORD_",
};

export const saveAudioBlobToIndexedDB = async (key: any, recordItem: any) => {
  const request = indexedDB.open(AudioDatabase.DB_NAME, 1);

  request.onupgradeneeded = (event: any) => {
    const db = event.target.result;
    db.createObjectStore(AudioDatabase.STORE, { keyPath: "key" });
  };

  request.onsuccess = (event: any) => {
    const db = event.target.result;
    const transaction = db.transaction(AudioDatabase.STORE, "readwrite");
    const store = transaction.objectStore(AudioDatabase.STORE);
    store.put({ key, recordItem });
    console.log("Audio Blob saved to IndexedDB.");
  };

  request.onerror = (event: any) => {
    console.error("IndexedDB error:", event.target.error);
  };
};

export const saveQuickRecordingItemToIndexedDB = async (
  key: any,
  recordingItem: any,
) => {
  const request = indexedDB.open(AudioDatabase.DB_NAME_QUICK_RECORD, 1);
  request.onupgradeneeded = (event: any) => {
    const db = event.target.result;
    db.createObjectStore(AudioDatabase.STORE_QUICK_RECORD, { keyPath: "key" });
  };
  request.onsuccess = (event: any) => {
    const db = event.target.result;
    const transaction = db.transaction(
      AudioDatabase.STORE_QUICK_RECORD,
      "readwrite",
    );
    const store = transaction.objectStore(AudioDatabase.STORE_QUICK_RECORD);
    store.put({ key, recordingItem });
    console.log("Quick Record Audio Blob saved to IndexedDB.");
  };
  request.onerror = (event: any) => {
    console.error("IndexedDB error:", event.target.error);
  };
};

export const getQuickRecordItemsFromIndexedDB = async () => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(AudioDatabase.DB_NAME_QUICK_RECORD, 1);
    request.onupgradeneeded = (event: any) => {
      const db = event.target.result;
      db.createObjectStore(AudioDatabase.STORE_QUICK_RECORD, {
        keyPath: "key",
      });
    };
    request.onsuccess = (event: any) => {
      const db = event.target.result;
      const transaction = db.transaction(
        AudioDatabase.STORE_QUICK_RECORD,
        "readonly",
      );
      const store = transaction.objectStore(AudioDatabase.STORE_QUICK_RECORD);
      const getRequest = store.getAll();
      getRequest.onsuccess = () => {
        resolve(getRequest.result ? getRequest.result : null);
      };
      getRequest.onerror = () => {
        reject(getRequest.error);
      };
    };
    request.onerror = (event: any) => {
      reject(event.target.error);
    };
  });
};

export const deleteQuickRecordItemFromIndexedDB = async (key: string) => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(AudioDatabase.DB_NAME_QUICK_RECORD, 1);
    request.onsuccess = (event: any) => {
      const db = event.target.result;
      const transaction = db.transaction(
        AudioDatabase.STORE_QUICK_RECORD,
        "readwrite",
      );
      const store = transaction.objectStore(AudioDatabase.STORE_QUICK_RECORD);
      const deleteRequest = store.delete(key);
      deleteRequest.onsuccess = () => {
        resolve(deleteRequest.result ? deleteRequest.result : null);
      };
      deleteRequest.onerror = () => {
        reject(deleteRequest.error);
      };
    };
    request.onerror = (event: any) => {
      reject(event.target.error);
    };
  });
};

export const getAudioBlobFromIndexedDB = async (key: string) => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(AudioDatabase.DB_NAME, 1);
    request.onsuccess = (event: any) => {
      const db = event.target.result;
      const transaction = db.transaction(AudioDatabase.STORE, "readonly");
      const store = transaction.objectStore(AudioDatabase.STORE);
      const getRequest = store.get(key);
      getRequest.onsuccess = () => {
        resolve(getRequest.result ? getRequest.result.recordItem : null);
      };
      getRequest.onerror = () => {
        reject(getRequest.error);
      };
    };

    request.onerror = (event: any) => {
      reject(event.target.error);
    };
  });
};

export const getLocalStorageItemsWithPrefix = (prefix: string) => {
  const items: any = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key?.startsWith(prefix)) {
      let patientRecord: any = localStorage.getItem(key);
      if (patientRecord) {
        patientRecord = JSON.parse(patientRecord);
        patientRecord = patientRecord.sort(sortByCreateDate);
        items.push(patientRecord.flat());
      }
    }
  }
  if (items.length > 0) {
    return items.flat().sort(sortByCreateDate);
  }
  return [];
};

export const addUpdatePatientRecords = (
  recordItem: any,
  storageKey: string,
) => {
  let patientRecord: any = localStorage.getItem(storageKey);
  if (!patientRecord) {
    patientRecord = [];
  } else {
    patientRecord = JSON.parse(patientRecord);
  }

  recordItem["storageKey"] = storageKey;

  const existingRecord = patientRecord.find(
    (item: any) => item.storagePath === recordItem.storagePath,
  );
  if (existingRecord) {
    patientRecord = [
      ...patientRecord.filter(
        (item: any) => item.storagePath !== recordItem.storagePath,
      ),
      recordItem,
    ];
  } else {
    patientRecord = [...patientRecord, recordItem];
  }

  localStorage.setItem(storageKey, JSON.stringify(patientRecord));
};

export const onSaveBlobToIndexDB = async (
  recordItem: any,
  storageKey: string,
) => {
  await saveAudioBlobToIndexedDB(
    `${storageKey}-${recordItem.name}`,
    recordItem,
  );
  addUpdatePatientRecords(recordItem, storageKey);
};
